ALLOWED_CONTROLLER = 'gateways'
ALLOWED_ACTIONS = ['logs_detail']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)
  $('#start_time').datetimepicker();
  $('#end_time').datetimepicker();


$(document).ready(ready)
$(document).on('turbo:load', ready)
